import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  Input,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import {
  LinkText,
  StyledCheckboxText,
  StyledInputField,
} from "@root/commonStyles/commonStyle";
import { ROUTE_NAMES, TOAST_VARIANT } from "@root/constants";
import { updatePasswordRecoverEmail } from "@root/store/slices/entities";
import { showAlert } from "@root/store/slices/features";
import { login, signup } from "@root/store/thunks";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { StyledAuthLinkOrTextBox } from "../login/styles";
import {
  SignupFormContainer,
  StyledSignupHeading,
  StyledSignupSubHeading,
  StyledSignupDescription,
} from "./styles";
import { useCountryContext } from "@root/context/use-country-context";

interface SignupValues {
  email: string;
  isConsant: boolean;
}

export const Signup: React.FC = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { country } =
    useCountryContext();

  const initialValues = {
    email: "",
    isConsant: false,
  };

  const onSuccessSocial = (res: any) => {
    if (!res?.token) {
      return;
    }
    setLoading(false);
    navigate(ROUTE_NAMES.DASHBOARD);
  };

  const onErrorSocial = () => {};

  const onSuccessHandler = (credentialResponse: any) => {
    const payload = { token: credentialResponse?.credential };
    dispatch(
      login({
        payload,
        isSocial: true,
        onSuccess: onSuccessSocial,
        onError: onErrorSocial,
      })
    );
  };

  const onSuccess = (email: any) => {
    setLoading(false);
    navigate(ROUTE_NAMES.EMAIL_VERIFICATION);
    dispatch(
      updatePasswordRecoverEmail({
        email,
      })
    );
  };
  const onError = () => {
    setLoading(false);
  };

  // const validate = (values: SignupValues) => {
  //   const errors: Partial<SignupValues> = {};

  //   if (!values.password) {
  //     errors.password = t("login.requiredPassword");
  //   } else if (values.password.length < 6) {
  //     errors.password = t("login.passwordValidation");
  //   }
  //   return errors;
  // };

  const onSubmit = (values: any) => {
    if (!values.isConsant) {
      dispatch(
        showAlert({
          message: t("signup.acceptStatus"),
          type: TOAST_VARIANT.ERROR,
        })
      );
      return;
    }
    setLoading(true);
    try {
      const payload = {
        email: values.email,
        ip_address: country?.IPv4,

      };
      dispatch(
        signup({
          payload,
          onSuccess: () => onSuccess(values?.email),
          onError,
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <SignupFormContainer>
      <StyledSignupHeading>{t("login.title")}</StyledSignupHeading>
      <StyledSignupSubHeading>
        <Text as="span" color="purple.500">
          {t("login.subTitle")}
        </Text>{" "}
      </StyledSignupSubHeading>
      <StyledSignupDescription>
        {t("login.description")}
      </StyledSignupDescription>

      <Formik
        // validate={validate}
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, errors, touched, values, setFieldValue }) => (
          <Form>
            <VStack
              mt="24px"
              spacing={"16px"}
              align="flex-start"
              border="1px solid"
              borderColor="#E6E9EF"
              borderRadius="24px"
              p="24px"
              width={{ base: "100%", md: "85%", lg: "95%" }}
              shadow="lg"
            >
              <FormControl>
                <StyledInputField
                  onChange={(e: any) => setFieldValue("email", e.target.value)}
                  borderColor={values.email ? "purple.500" : "gray.200"}
                  as={Input}
                  id="email"
                  name="email"
                  type="email"
                  required
                  variant="filled"
                  placeholder={t("login.emailAddress")}
                  backgroundColor={"white"}
                  height={"48px"}
                />
              </FormControl>
              {/* <FormControl isInvalid={!!errors.password && touched.password}>
                <PasswordInput
                  // @ts-ignore
                  backgroundColor={"white"}
                  onChange={(e: any) =>
                    setFieldValue("password", e.target.value)
                  }
                  borderColor={values.password ? "purple.500" : "gray.200"}
                  value={values.password}
                  id="password"
                  name="password"
                  required
                  placeholder={t("login.password")}
                  // @ts-ignore
                  validate={(value: string) => {
                    let error;

                    if (value.length < 6) {
                      error = t("signup.passwordContain");
                    }

                    return error;
                  }}
                />
                <FormErrorMessage>{errors.password}</FormErrorMessage>
              </FormControl> */}
              <Box width={"100%"}>
                <Button
                  type="submit"
                  isLoading={loading}
                  colorScheme="purple"
                  width="full"
                  height={"48px"}
                  fontWeight={500}
                  fontFamily="Noto Sans KR, sans-serif"
                  fontSize={"16px"}
                  background="linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)"
                  _hover={{
                    background:
                      "linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)",
                  }}
                >
                  <Box>{t("signup.signupBtn")}</Box>
                </Button>
              </Box>
              <Box w="full" display={"flex"} alignItems={"center"} gap={"16px"}>
                <Box mt={"6px"}>
                  <Field
                    colorScheme={"purple"}
                    as={Checkbox}
                    id="isConsant"
                    name="isConsant"
                  />
                </Box>
                <StyledCheckboxText>
                  {`${t("signup.creatingAccount")} `}
                  <Link to={ROUTE_NAMES.PRIVACY_POLICY}>
                    <Text fontWeight={500} display={"inline"} color={"#0D0D0D"}>
                      {" "}
                      {t("signup.privacyPolicy")}
                    </Text>
                  </Link>
                  {t("signup.and")}
                  <Link
                    color={"primaryGreen.100"}
                    to={ROUTE_NAMES.TERMS_CONDITION}
                  >
                    <Text
                      fontSize={"14px"}
                      fontWeight={500}
                      display={"inline"}
                      color={"#0D0D0D"}
                    >
                      {" "}
                      {t("signup.terms")}
                    </Text>
                  </Link>
                  {t("signup.last")}
                </StyledCheckboxText>
              </Box>
            </VStack>
          </Form>
        )}
      </Formik>
      <StyledAuthLinkOrTextBox>
        <StyledCheckboxText>{t("signup.alreadyAccount")}</StyledCheckboxText>
        <LinkText to={"/login"} color={"purple.500"} fontSize={"14px"}>
          {t("login.loginLink")}
        </LinkText>
      </StyledAuthLinkOrTextBox>
    </SignupFormContainer>
  );
};
